import apiClient from './client';
import { normalizeCanvasItem } from './canvas-items';

import type { CanvasAssetType, CanvasContextType } from '@/types/canvas';
import type { CanvasSnapshot, CanvasTargetHistory } from '@/types/canvas-snapshot';
import type { GenerationTargetKey } from '@/types/generation-reference';

export interface CanvasSnapshotQuery {
  projectId: string;
  contextType: CanvasContextType;
  assetType?: CanvasAssetType | null;
  assetId?: string | null;
  storyboardId?: string | null;
  conversationMessageLimit?: number;
}

function serializeTarget(target: GenerationTargetKey) {
  return {
    targetType: target.targetType,
    targetId: target.targetId,
    tagId: target.tagId ?? undefined,
    planId: target.planId ?? undefined,
    mediaType: target.mediaType,
  };
}

export const canvasSnapshotApi = {
  async getSnapshot(params: CanvasSnapshotQuery): Promise<CanvasSnapshot> {
    const response = (await apiClient.get(`/projects/${params.projectId}/canvas/snapshot`, {
      params: {
        contextType: params.contextType,
        assetType: params.assetType ?? undefined,
        assetId: params.assetId ?? undefined,
        storyboardId: params.storyboardId ?? undefined,
        conversationMessageLimit: params.conversationMessageLimit,
      },
    })) as unknown as CanvasSnapshot;

    return {
      ...response,
      contextType: params.contextType,
      assetType: params.assetType ?? null,
      canvasItems: response.canvasItems.map(normalizeCanvasItem),
      audioResults: response.audioResults ?? [],
    };
  },

  getHistory(params: {
    projectId: string;
    contextType: CanvasContextType;
    target: GenerationTargetKey;
    assetType?: CanvasAssetType | null;
    assetId?: string | null;
    storyboardId?: string | null;
    /** 视频展开时锚定 versions 链的 videoId。 */
    resourceId?: string | null;
    page?: number;
    pageSize?: number;
  }): Promise<CanvasTargetHistory> {
    return apiClient.get(`/projects/${params.projectId}/canvas/history`, {
      params: {
        contextType: params.contextType,
        assetType: params.assetType ?? undefined,
        assetId: params.assetId ?? undefined,
        contextStoryboardId: params.storyboardId ?? undefined,
        ...serializeTarget(params.target),
        resourceId: params.resourceId ?? undefined,
        page: params.page,
        pageSize: params.pageSize,
      },
    });
  },
};
